import {
  Button,
  Col,
  Divider,
  Input,
  message,
  notification,
  Row,
  Select,
  Checkbox,
} from "antd";
import { LockFilled } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { register, registerLoading } from "../../actions/authActions";
import MapComponent from "../../Components/MapComponent";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import { mapOptions } from "../../Components/MapComponent/MapConfig";
import axios from "axios";
import { get_v10_url } from "../../utils/commonUtilities";
import Cookies from "js-cookie";
import TextArea from "antd/lib/input/TextArea";
import registerImage from "../../Assets/images/register-image.png";
import logoTitle from "../../Assets/images/plunes-logo-text.png";
import TermsConditionsModal from "../../Components/TermsConditionsModal";
import GlobalLoader from "../../Components/GlobalLoader";

const plusIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 2C6 1.46957 6.21071 0.960859 6.58579 0.585786C6.96086 0.210714 7.46957 0 8 0H10C10.5304 0 11.0391 0.210714 11.4142 0.585786C11.7893 0.960859 12 1.46957 12 2V6H16C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8V10C18 10.5304 17.7893 11.0391 17.4142 11.4142C17.0391 11.7893 16.5304 12 16 12H12V16C12 16.5304 11.7893 17.0391 11.4142 17.4142C11.0391 17.7893 10.5304 18 10 18H8C7.46957 18 6.96086 17.7893 6.58579 17.4142C6.21071 17.0391 6 16.5304 6 16V12H2C1.46957 12 0.960859 11.7893 0.585786 11.4142C0.210714 11.0391 0 10.5304 0 10V8C0 7.46957 0.210714 6.96086 0.585786 6.58579C0.960859 6.21071 1.46957 6 2 6H6V2Z"
      fill="#5E5D5D"
    />
  </svg>
);

const mailIcon = (
  <svg
    width="20"
    height="15"
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.172 8.834L10.002 10.769L12.73 8.887L18.845 14.92C18.684 14.972 18.512 15 18.333 15H1.667C1.447 15 1.237 14.957 1.044 14.88L7.172 8.834ZM20 3.876V13.333C20 13.58 19.946 13.814 19.85 14.025L13.856 8.111L20 3.876ZM9.43602e-07 3.929L6.042 8.061L0.106001 13.919C0.0356967 13.7316 -0.000212233 13.5331 9.43602e-07 13.333V3.929ZM18.333 0C19.253 0 20 0.746 20 1.667V2.253L9.998 9.148L9.43602e-07 2.31V1.667C9.43602e-07 0.747 0.746001 0 1.667 0H18.333Z"
      fill="#5E5D5D"
    />
  </svg>
);

const lockIcon = (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.89 4.82L6.25 3.16C6.61681 2.22836 7.25557 1.4287 8.08313 0.865101C8.91069 0.301501 9.88875 5.71153e-05 10.89 0C13.65 0 15.89 2.24 15.89 5V7H16.89C17.4204 7 17.9291 7.21071 18.3042 7.58579C18.6793 7.96086 18.89 8.46957 18.89 9V15.8L10.09 7H13.89V5C13.89 3.34 12.55 2 10.89 2C9.3 2 8 3.25 7.89 4.82ZM21 20.46L19.73 21.73L18.35 20.35C17.99 20.75 17.47 21 16.89 21H4.89C3.78 21 2.89 20.11 2.89 19V9C2.89 8.46957 3.10071 7.96086 3.47579 7.58579C3.85086 7.21071 4.35957 7 4.89 7H5L0 2L1.28 0.73L21 20.46ZM12.74 14.74L10.15 12.15C9.39 12.44 8.89 13.16 8.89 14C8.89 14.5304 9.10071 15.0391 9.47579 15.4142C9.85086 15.7893 10.3596 16 10.89 16C11.73 16 12.45 15.5 12.74 14.74Z"
      fill="#5E5D5D"
    />
  </svg>
);

const mobileIcon = (
  <svg
    width="15"
    height="24"
    viewBox="0 0 15 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 0H2.25C1.0125 0 0 1.0125 0 2.25V21.75C0 22.9875 1.0125 24 2.25 24H12.75C13.9875 24 15 22.9875 15 21.75V2.25C15 1.0125 13.9875 0 12.75 0ZM4.5 1.125H10.5V1.875H4.5V1.125ZM7.5 22.5C7.10218 22.5 6.72064 22.342 6.43934 22.0607C6.15804 21.7794 6 21.3978 6 21C6 20.6022 6.15804 20.2206 6.43934 19.9393C6.72064 19.658 7.10218 19.5 7.5 19.5C7.89782 19.5 8.27936 19.658 8.56066 19.9393C8.84196 20.2206 9 20.6022 9 21C9 21.3978 8.84196 21.7794 8.56066 22.0607C8.27936 22.342 7.89782 22.5 7.5 22.5ZM13.5 18H1.5V3H13.5V18Z"
      fill="#5E5D5D"
    />
  </svg>
);

const locationIcon = (
  <svg
    width="14"
    height="20"
    viewBox="0 0 14 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 9.5C6.33696 9.5 5.70107 9.23661 5.23223 8.76777C4.76339 8.29893 4.5 7.66304 4.5 7C4.5 6.33696 4.76339 5.70107 5.23223 5.23223C5.70107 4.76339 6.33696 4.5 7 4.5C7.66304 4.5 8.29893 4.76339 8.76777 5.23223C9.23661 5.70107 9.5 6.33696 9.5 7C9.5 7.3283 9.43534 7.65339 9.3097 7.95671C9.18406 8.26002 8.99991 8.53562 8.76777 8.76777C8.53562 8.99991 8.26002 9.18406 7.95671 9.3097C7.65339 9.43534 7.3283 9.5 7 9.5ZM7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0Z"
      fill="#5E5D5D"
    />
  </svg>
);

function Register(props) {
  const [showTermsConditionModal, setShowTermsConditionModal] = useState(false);
  const [platformSubscriptionFee, setPlatformSubscriptionFee] =
    useState(undefined);
  const [data, setData] = useState({
    rohiniId: '',
    name: "",
    email: "",
    // phoneNo: '',
    password: "",
    confirmPassword: "",
    address: "",
    manualAddress: "",
    // hospitalType: undefined,
    // careType: undefined,
    // ppnStatus: undefined,
    // place: '',
    // state: '',
    // city: '',
    // pinCode: '',
    mobileNo: "",
    // medicalSuperintendent: '',
    // tpaHead: '',
    // hospitalRegistrationNo: '',
    // registringAuthority: '',
    // rohiniCode: '',
    // hospitalPAN: '',
    // panHolderName: '',
    // impatientBeds: undefined,
    // dayCarebeds: undefined,
    // icuBeds: undefined,
    // accountNo: '',
    // ifscCode: '',
    // branchAddress: '',
    // contactNo: '',
    // biograpgy: '',
    // specialities_selected: [],
    location: {},
    // adminEmail: '',
    // adminPassword: ''
  });
  const [specialities, setSpecialities] = useState([]);

  const [registerationSteps, setRegisterationSteps] = useState(1); // step count to implement the next and prev button functionalty.
  const [autoCompleteResults, setAutoCompleteResults] = useState(null);
  const [loading, setLoading] = useState(false)

  // const handleAddressChange = (address) => {
  //     setData({...data, address: address, location: getCoordinatesFromAddress(address)})
  // }

  const [showPassword, setShowPassword] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [representativeName, setRepresentativeName] = useState("");
  const [representativeDesignation, setRepresentativeDesignation] =
    useState("");

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const toggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const onLoad = (autoComplete) => {
    setAutoCompleteResults(autoComplete);
  };

  const handleSelectedPlace = () => {
    // console.log({autoCompleteResults});
    if (autoCompleteResults) {
      const place = autoCompleteResults.getPlace();
      const lat = place.geometry?.location.lat();
      const lng = place.geometry?.location.lng();
      // console.log("address: ", place);
      setData({
        ...data,
        address: place.formatted_address,
        location: { lat, lng },
      });
    }
  };

  const getCoordinatesFromAddress = async (address) => {
    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          address
        )}&key=${mapOptions.GoogleMapsAPI}`
      );
      const data = await res.json();
      if (data.results && data.results.length > 0) {
        const location = data.results[0].geometry.location;
        return { lat: location.lat, lng: location.lng };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  // const submitDetails = () => {
  //   if(data.confirmPassword !== data.password)
  //       openNotificationWithIcon()
  //   else {
  //     props.register({
  //         email: data.email,
  //         mobileNumber: data.phoneNo,
  //         password: data.password,
  //         name: data.userName,
  //         address: data.address,
  //         location: data.location,
  //     })
  //   }
  // }
  // const [registerationSteps, setRegisterationSteps] = useState(1) // step count to implement the next and prev button functionalty.

  // // var to autocomplete the address input
  // const [autoCompleteAddress, setAutoCompleteAddress] = useState([]);

  const handleAddressChange = (address) => {
    setData({ ...data, address: address });
    // fetchAddressPredictions(address)
  };

  const checkForEmptyField = (obj) => {
    try {
      Object.keys(obj).forEach(key => {
        if (obj[key] === '' || obj[key] === undefined) {
          if(key === 'rohiniId') {
            throw new Error('Rohini Id not entered')
          }
          if(key === 'name') {
            throw new Error('Hospital name not entered')
          }
          if (key === "email") {
            throw new Error("Email address not entered");
          }
          if (key === "password") {
            throw new Error("Password not entered");
          }
          if (key === "confirmPassword") {
            throw new Error("Confirm Password not entered");
          }
          if (key === "manualAddress") {
            throw new Error("Address not entered");
          }
          if (key === "address") {
            throw new Error("Search address not entered");
          }
          if (key === "mobileNo") {
            throw new Error("Mobile number not entered");
          }
        }
      });
    } catch (e) {
      return String(e);
    }
    return true;
  };

  const checkTrailingSpaces = () => {
    const trailRegex = /\s+$/;
    if (
      trailRegex.test(data.name) ||
      !(data.name.trimStart().length === data.name.length)
    ) {
      openNotificationWithIcon("Avoid using trailing spaces in hospital name");
      return true;
    }
    if (
      trailRegex.test(data.address) ||
      !(data.address.trimStart().length === data.address.length)
    ) {
      openNotificationWithIcon("Avoid using trailing spaces in address");
      return true;
    }
    if (
      trailRegex.test(data.email) ||
      !(data.email.trimStart().length === data.email.length)
    ) {
      openNotificationWithIcon("Avoid using trailing spaces in email");
      return true;
    }
    if (
      trailRegex.test(data.mobileNo) ||
      !(data.mobileNo.trimStart().length === data.mobileNo.length)
    ) {
      openNotificationWithIcon("Avoid using trailing spaces in mobile number");
      return true;
    }
    return false;
  };

  useEffect(() => {
    axios.get(`${get_v10_url()}/catalogue/getSpecialities`).then((res) => {
      const specialities = res.data.data;
      let array = [];
      specialities.forEach((s) => {
        let data = {
          name: s.speciality,
          id: s.specialityId,
          value: s.speciality,
        };
        array.push(data);
      });
      setSpecialities(array);
    });
  }, []);

  // const fetchAddressPredictions = (input) => {
  //     const autoCompleteService = new window.google.maps.places.AutocompleteService();
  //     autoCompleteService.getPlacePredictions({input}, (predictions, status) => {
  //         if(status === window.google.maps.places.PlacesServiceStatus.OK) {
  //             setAutoCompleteAddress(predictions)
  //         } else {
  //             setAutoCompleteAddress([]);
  //         }
  //     })
  // }

  // const handleSelectedPrediction = (prediction) => {
  //     setData({...data, address: prediction.description})
  //     setAutoCompleteAddress([]);
  // }

  const submitDetails = async () => {
    console.log("desi", representativeDesignation);
    console.log("name", representativeName);
    if (data.confirmPassword !== data.password) {
      openNotificationWithIcon("Password does not match");
      return;
    }
    const isAllGood = checkForEmptyField(data);
    if (typeof isAllGood === "string") {
      openNotificationWithIcon(isAllGood);
      return;
    }
    if (!termsChecked) {
      openNotificationWithIcon(
        "Please check the terms and conditions before registering."
      );
      return;
    }
    if (!platformSubscriptionFee) {
      openNotificationWithIcon(
        "Please enter the subscription fee before registering."
      );
      return;
    }
    if (platformSubscriptionFee < 0) {
      openNotificationWithIcon(
        "Subscription fee cannot be negative."
      );
      return;
    }
    if (!representativeName) {
      openNotificationWithIcon(
        "Please enter the representative name before registering."
      );
      return;
    }
    if (!representativeDesignation) {
      openNotificationWithIcon(
        "Please enter the representative designation before registering."
      );
      return;
    }
    if (data.email !== "") {
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!emailRegex.test(data.email)) {
        openNotificationWithIcon("Please enter a valid email address");
        return;
      }
    }
    if (data.mobileNo.length !== 10) {
      openNotificationWithIcon("Please enter a 10-digit mobile number");
      return;
    }
    if (checkTrailingSpaces()) {
      return;
    }
    if (data.password.length < 8) {
      openNotificationWithIcon("Password must contain at least 8 characters");
      return;
    }

    // props.register({
    //   email: data.email,
    //   mobileNumber: data.phoneNo,
    //   password: data.password,
    //   name: data.userName,
    //   userAddress: data.address
    // })
    await handleSaveData();
  };

  const handleSaveData = async () => {
    setLoading(true)
    try {
      // let arr = [...data.specialities_selected]
      // arr = arr.map((item, i) => {
      //   let id = ''
      //   specialities.forEach((d, j) => {
      //     if (d.name === item) {
      //       id = d.id
      //     }
      //   })
      //   return {
      //     specialityId: id,
      //     services: []
      //   }
      // })

      // https://devapi.plunes.com/v10/professional/register
      const response = await axios.post(
        `${get_v10_url()}/professional/register`,
        {
          name: data.name,
          address: data.manualAddress,
          mobileNumber: data.mobileNo,
          timeOfRegister: Date.now(),
          // phoneNumber: data.phoneNo,
          // hospitalRegistrationNo: data.hospitalRegistrationNo,
          // biograpgy: data.biograpgy,
          // specialities: arr,
          email: data.email,
          password: data.password,
          platformSubscriptionFee: +platformSubscriptionFee,
          representativeName: representativeName,
          representativeDesignation: representativeDesignation,
          rohiniId: data.rohiniId,
          location: {
            coordinates: [data.location?.lng, data.location?.lat],
          },
          // regno: data.hospitalRegistrationNo,

          // adminEmail: data.adminEmail,
          // adminPassword: data.adminPassword,
          // hospitalType: data.hospitalType,
          // careType: data.careType,
          // ppnStatus: data.ppnStatus,
          // place: data.place,
          // state: data.state,
          // city: data.city,
          // pinCode: data.pinCode,
          // medicalSuperintendent: data.medicalSuperintendent,
          // tpaHead: data.tpaHead,
          // registringAuthority: data.registringAuthority,
          // rohiniCode: data.rohiniCode,
          // hospitalPAN: data.hospitalPAN,
          // panHolderName: data.panHolderName,

          // inpatientBeds: data.impatientBeds,
          // dayCareBeds: data.dayCarebeds,
          // icuBeds: data.icuBeds,

          // accountNumber: data.accountNo,
          // ifscCode: data.ifscCode,
          // branchAddress: data.branchAddress,
          // contactNumber: data.contactNo,
          userType: "Hospital",
        }
      );
      if (response.status === 200) {
        if (response.data.success) {
          message.success("Registration Successful");
          props.setLoginScreen();
        }
        setLoading(false)
      } else {
        console.error("DATA NOT POST");
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error("ERROR POSTING DATA: ", error);
      if (Object.keys(error?.response?.data).includes("message")) {
        openNotificationWithIcon(error?.response?.data.message);
      }
    }
  };

  const openNotificationWithIcon = (msg) => {
    notification["error"]({
      message: msg,
      //   description:
      //     'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
    });
  };

  const handleSpecialitySelect = (e) => {
    try {
      let arr = [...data.specialities_selected];
      if (arr.includes(e)) {
        openNotificationWithIcon(`${e} already selected`);
        return;
      }

      arr.unshift(e);
      setData({
        ...data,
        specialities_selected: arr,
      });
    } catch (err) {
      console.log(e);
    }
  };

  const removeSpeciality = (d) => {
    let arr = JSON.parse(JSON.stringify(data.specialities_selected));
    let i = arr.indexOf(d);
    arr.splice(i, 1);
    setData({
      ...data,
      specialities_selected: arr,
    });
  };

  return (
    <>
    {loading && <GlobalLoader/>}
    <div className="auth-page-container fade-in register">
      <div className="dot child-1"></div>
      {/* <div className='dot child-2'></div> */}
      <div className="dot child-3"></div>
      <div className="circle child1"></div>
      <div className="circle child2"></div>
      <Row className="auth-page-row" align="top">
        <Col className="auth-image-container" span={14}>
          <h3>Sign-Up To Create Your Account</h3>
          <img className="login-left-image" src={registerImage} />
        </Col>
        <Col className="auth-form-container" span={10}>
          <div className="auth-box" style={{ width: "100%" }}>
            <img className="auth-box-image" src={logoTitle} />
            <div className="auth-page-controller">
              <Button
                onClick={() => props.setLoginScreen()}
                className="page-button"
              >
                Login
              </Button>
              {/* <Divider type='vertical' /> */}
              <Button
                onClick={() => console.log("Noted")}
                className="page-button active"
              >
                Register
              </Button>
            </div>
            <div
              style={{
                overflowY: "scroll",
                overflowX: "clip",
                height: "calc(100vh - 300px)",
                backgroundColor: "#FFFFFF",
                padding: "0.5rem 1.5rem",
              }}
            >
              {/* <LoadScript
                      googleMapsApiKey={mapOptions.GoogleMapsAPI}
                      libraries={["places"]}
                      onUnmount={() => {console.error("Unmounted!!!")}}
                  > */}
              {registerationSteps === 1 && (
                <React.Fragment>
                  <span className="label-text">Hospital Name*</span>
                  <Input
                    onChange={(e) => {
                      e.preventDefault();
                      setData({ ...data, name: e.target.value });
                    }}
                    className="auth-input"
                    placeholder="Hospital Name"
                    suffix={plusIcon}
                    value={data.name}
                  />
                  <span className="label-text">Email ID*</span>
                  <Input
                    onChange={(e) => {
                      e.preventDefault();
                      setData({ ...data, email: e.target.value });
                    }}
                    className="auth-input"
                    placeholder="Email Address"
                    suffix={mailIcon}
                    value={data.email}
                  />
                  <span className="label-text">Mobile Number*</span>
                  <Input
                    onChange={(e) => {
                      e.preventDefault();
                      setData({ ...data, mobileNo: e.target.value });
                    }}
                    className="auth-input"
                    placeholder="Mobile Number"
                    suffix={mobileIcon}
                    value={data.mobileNo}
                  />
                  <span className='label-text'>ROHINI*</span>
                  <Input
                    onChange={e => {
                      e.preventDefault()
                      setData({ ...data, rohiniId: e.target.value })
                    }}
                    className='auth-input'
                    placeholder='Rohini Id'
                    suffix={mobileIcon}
                    value={data.rohiniId}
                  />
                  <span className='label-text'>Password*</span>
                  <Input
                    onChange={(e) => {
                      e.preventDefault();
                      setData({ ...data, password: e.target.value });
                    }}
                    type={showPassword ? "text" : "password"}
                    className="auth-input last"
                    placeholder="Password"
                    suffix={
                      <div
                        onClick={togglePassword}
                        style={{ cursor: "pointer", marginTop: "5px" }}
                      >
                        {showPassword ? (
                          <LockFilled
                            style={{ color: "#5E5D5D", fontSize: "20px" }}
                          />
                        ) : (
                          lockIcon
                        )}
                      </div>
                    }
                    value={data.password}
                  />
                  <span className="label-text">Confirm Password*</span>
                  <Input
                    onChange={(e) => {
                      e.preventDefault();
                      setData({ ...data, confirmPassword: e.target.value });
                    }}
                    type={showConfirmPassword ? "text" : "password"}
                    className="auth-input last"
                    placeholder="Confirm Password"
                    suffix={
                      <div
                        onClick={toggleConfirmPassword}
                        style={{ cursor: "pointer", marginTop: "5px" }}
                      >
                        {showConfirmPassword ? (
                          <LockFilled
                            style={{ color: "#5E5D5D", fontSize: "20px" }}
                          />
                        ) : (
                          lockIcon
                        )}
                      </div>
                    }
                    value={data.confirmPassword}
                  />

                  {/* <Input
                    onChange={e => {
                      e.preventDefault()
                      handleAddressChange(e.target.value)
                    }}
                    className='auth-input'
                    placeholder='Address'
                    suffix={<i className='fas fa-map-marker-alt' />}
                    value={data.address}
                  /> */}
                  <span className="label-text">Address*</span>
                  <Input
                    onChange={(e) => {
                      e.preventDefault();
                      setData({ ...data, manualAddress: e.target.value });
                    }}
                    className="auth-input"
                    placeholder="Address"
                    suffix={locationIcon}
                    value={data.manualAddress}
                  />

                  <span className="label-text">Search Location*</span>
                  <Autocomplete
                    onLoad={onLoad}
                    onPlaceChanged={handleSelectedPlace}
                  >
                    <Input
                      onChange={(e) => {
                        e.preventDefault();
                        handleAddressChange(e.target.value);
                      }}
                      className="auth-input"
                      placeholder="Enter address to search for locality"
                      suffix={locationIcon}
                      value={data.address}
                    />
                  </Autocomplete>
                  <MapComponent locationCoordinates={data.location} />

                  {/* <Input
                    onChange={e => {
                      e.preventDefault()
                      setData({ ...data, adminEmail: e.target.value })
                    }}
                    className='auth-input'
                    placeholder='Admin Email'
                    suffix={<i className='fas fa-envelope' />}
                    value={data.adminEmail}
                    style={{ marginTop: '20px' }}
                  />

                  <Input
                    onChange={e => {
                      e.preventDefault()
                      setData({ ...data, adminPassword: e.target.value })
                    }}
                    type='password'
                    className='auth-input last'
                    placeholder='Admin Password'
                    suffix={<i className='fas fa-shield-alt' />}
                    value={data.adminPassword}
                    style={{ marginBottom: '-10px' }}
                  /> */}
                  {/* <Checkbox onChange={(e)=>setTermsChecked(e.target.checked)} className='terms-container'>
                    <p className='terms-condition'>Check here to indicate that you have read and agree to the <a href='https://www.plunes.com/terms-of-use'>Terms and Conditions</a> agreement.</p>
                  </Checkbox> */}
                  <div className="terms-conditions-container">
                    <div className="terms-conditions-head">
                      Terms & Conditions{" "}
                    </div>
                    <div className="terms-conditions-text">
                      We are AWC Technologies Private Limited ('operating under brand
                      names
                      <b> Plunes</b>', &#39;<b>Company</b>&#39;, or &#39;<b>We</b>&#39;),
                      a company registered in India under the Companies Act, 2013, having
                      the CIN - U74999DL2016PTC304426...
                    </div>
                    <div className="terms-conditions-view">
                      <Checkbox
                        checked={termsChecked}
                        value={termsChecked}
                        onChange={(e) =>
                          setTermsChecked(() => e.target.checked)
                        }
                        className="terms-conditions-checkbox"
                      >
                        <p
                          style={{ margin: "0px" }}
                          className="terms-conditions-checkbox-text"
                        >
                          I Agree Terms & Conditions
                        </p>
                      </Checkbox>
                      <div
                        onClick={() => setShowTermsConditionModal(true)}
                        className="terms-conditons-view-more"
                      >
                        View More
                      </div>
                    </div>
                  </div>
                  <TermsConditionsModal
                    openTermsConditionModal={showTermsConditionModal}
                    setOpenTermsConditionModal={setShowTermsConditionModal}
                    termsChecked={termsChecked}
                    setTermsChecked={setTermsChecked}
                    platformSubscriptionFee={platformSubscriptionFee}
                    setPlatformSubscriptionFee={setPlatformSubscriptionFee}
                    representativeName={representativeName}
                    setRepresentativeName={setRepresentativeName}
                    representativeDesignation={representativeDesignation}
                    setRepresentativeDesignation={setRepresentativeDesignation}
                    hospitalName={data.name}
                  />
                  <Button
                    onClick={() => submitDetails()}
                    className="submit-btn"
                  >
                    Create Account
                  </Button>
                </React.Fragment>
              )}

              {/* <Button className="forgot-password">Forgot Password</Button> */}
              {/* {registerationSteps === 2 && (
                <div style={{ width: '100%' }}>
                  <h2>General Information</h2>
                  <Row gutter={24} style={{ marginBottom: '15px' }}>
                    <Col span={12}>
                      <Select
                        type='select'
                        options={[
                          {
                            label: 'Single Speciality',
                            value: 'Single Speciality'
                          },
                          {
                            label: 'Multi Speciality',
                            value: 'Multi Speciality'
                          }
                        ]}
                        onChange={e => {
                          setData({ ...data, hospitalType: e })
                        }}
                        name='insurance'
                        value={data.hospitalType}
                        placeholder='Hospital Type'
                        className='booking-dropdown-container'
                        style={{ width: '100%' }}
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        type='select'
                        // disabled={loading}
                        options={[
                          {
                            label: 'Primary Care',
                            value: 'Primary Care'
                          },
                          {
                            label: 'Secondary Care',
                            value: 'Secondary Care'
                          },
                          {
                            label: 'Tertiary Care',
                            value: 'Tertiary Care'
                          }
                        ]}
                        onChange={e => {
                          setData({ ...data, careType: e })
                        }}
                        name='careType'
                        value={data.careType}
                        placeholder='Choose care type'
                        className='booking-dropdown-container'
                        style={{ width: '100%' }}
                      />
                    </Col>
                  </Row>
                  <Row style={{marginBottom: "1.25rem"}} gutter={24}>
                    <Col span={12}>
                      <Select
                        type='select'
                        // disabled={loading}
                        options={[
                          {
                            label: 'PPN',
                            value: 'PPN'
                          },
                          {
                            label: 'Non-PPN',
                            value: 'Non-PPN'
                          }
                        ]}
                        onChange={e => setData({ ...data, ppnStatus: e })}
                        name='ppnStatus'
                        value={data.ppnStatus}
                        placeholder='Choose PPN Status'
                        className='booking-dropdown-container'
                        style={{ width: '100%' }}
                      />
                    </Col>
                    {/* <Col span={12}>
                      <Input
                        value={data.hospitalName}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, hospitalName: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Hospital Name'
                      />
                    </Col> */}
              {/* </Row>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Input
                        value={data.place}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, place: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Place'
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        value={data.state}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, state: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='State'
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Input
                        value={data.city}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, city: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='City'
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        value={data.pinCode}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, pinCode: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='PIN Code'
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Input
                        value={data.phoneNo}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, phoneNo: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Phone Number'
                      />
                    </Col>
                    {/* <Col span={12}>
                      <Input
                        value={data.mobileNo}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, mobileNo: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Mobile No'
                      />
                    </Col> */}
              {/* </Row>
                  <Row gutter={24}> */}
              {/* <Col span={12}>
                      <Input
                        value={data.hospitalEmail}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, hospitalEmail: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Email ID'
                      />
                    </Col> */}
              {/* <Col span={12}>
                      <Input
                        value={data.medicalSuperintendent}
                        onChange={e => {
                          e.preventDefault()
                          setData({
                            ...data,
                            medicalSuperintendent: e.target.value
                          })
                        }}
                        className='auth-input'
                        placeholder='Medical Superintendent'
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Input
                        value={data.tpaHead}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, tpaHead: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Marketing / TPA Head'
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        value={data.hospitalRegistrationNo}
                        onChange={e => {
                          e.preventDefault()
                          setData({
                            ...data,
                            hospitalRegistrationNo: e.target.value
                          })
                        }}
                        className='auth-input'
                        placeholder='Hospital Registration No'
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Input
                        value={data.registringAuthority}
                        onChange={e => {
                          e.preventDefault()
                          setData({
                            ...data,
                            registringAuthority: e.target.value
                          })
                        }}
                        className='auth-input'
                        placeholder='Registering Authority'
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        value={data.rohiniCode}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, rohiniCode: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Rohini Code'
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Input
                        value={data.hospitalPAN}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, hospitalPAN: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Hospital PAN'
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        value={data.panHolderName}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, panHolderName: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='PAN Holder Name'
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <TextArea
                        type='textarea'
                        value={data.biograpgy}
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, biograpgy: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Biography'
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Select
                        options={specialities}
                        placeholder='Choose Specialities'
                        name='specialities'
                        className='booking-dropdown-container'
                        style={{ width: '100%' }}
                        onChange={e => handleSpecialitySelect(e)}
                      />
                    </Col>
                  </Row>
                  <Row
                    gutter={24}
                    style={{
                      margin: '10px 0px 0px 0px',
                      justifyContent: 'center'
                    }}
                  >
                    {data.specialities_selected.map((spec, idx) => (
                      <Col
                        id={idx}
                        span={11}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '1px solid lightgray',
                          borderRadius: '5px',
                          padding: '5px 10px',
                          margin: '5px'
                        }}
                      >
                        <span style={{ flexGrow: '1' }}>{spec}</span>
                        <span
                          onClick={() => removeSpeciality(spec)}
                          style={{ cursor: 'pointer' }}
                        >
                          X
                        </span>
                      </Col>
                    ))}
                  </Row>

                  <h2 style={{ marginTop: '20px' }}>Basic Information</h2>
                  <Row gutter={24}>
                    <Col span={8}>
                      <Input
                        type='number'
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, impatientBeds: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Inpatient Beds'
                        value={data.impatientBeds}
                      />
                    </Col>
                    <Col span={8}>
                      <Input
                        type='number'
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, dayCarebeds: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Day Care Beds'
                        value={data.dayCarebeds}
                      />
                    </Col>
                    <Col span={8}>
                      <Input
                        type='number'
                        onChange={e => {
                          e.preventDefault()
                          setData({ ...data, icuBeds: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='ICU Beds'
                        value={data.icuBeds}
                      />
                    </Col>
                  </Row>

                  <h2>Account Information</h2>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Input
                        value={data.accountNo}
                        onChange={e => {
                          setData({ ...data, accountNo: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Account No'
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        value={data.ifscCode}
                        onChange={e => {
                          setData({ ...data, ifscCode: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='IFSC Code'
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Input
                        value={data.branchAddress}
                        onChange={e => {
                          setData({ ...data, branchAddress: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Branch Address'
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        value={data.contactNo}
                        onChange={e => {
                          setData({ ...data, contactNo: e.target.value })
                        }}
                        className='auth-input'
                        placeholder='Account Dept Contact No'
                      />
                    </Col>
                  </Row>

                  <Row gutter={24}>
                    <Col span={12}>
                      <Button
                        onClick={() => setRegisterationSteps(1)}
                        className='submit-btn'
                        style={{
                          background: 'white',
                          color: 'black',
                          borderColor: '#2BBC52'
                        }}
                      >
                        Previous
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button
                        onClick={() => submitDetails()}
                        className='submit-btn'
                      >
                        Create Account
                      </Button>
                    </Col>
                  </Row>
                </div>
              )} */}
              {/* </LoadScript> */}
            </div>
          </div>
        </Col>
      </Row>
    </div>
    </>
  );
}

export default Register;
